import axios from 'axios';
import cookie from 'js-cookie';

// Get the API base URL from environment variables or use a default
const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Change user password
 * @param {Object} passwordData - Object containing currentPassword and newPassword
 * @returns {Promise<Object>} - Response data
 */
export const changePassword = async (passwordData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/user/change-password`, passwordData, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error changing password:', error);
        throw error;
    }
};
